<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" class="ele-form-search ele-form-mysearch d-flex f-end"
               @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
            <el-form-item label="选择状态:" label-width="80px" class="w-200">
              <el-select v-model="table.where.pay_type" placeholder="请选择" clearable class="ele-fluid">
                <el-option  label="全部" value="10"/>
                <el-option  label="成功" value="1"/>
                <el-option label="失败" value="2"/>
              </el-select>
            </el-form-item>
            <el-form-item label="订单编号:" label-width="74px" class="w-300">
              <el-input v-model="table.where.order_id" placeholder="请输入订单编号" clearable/>
            </el-form-item>
            <el-form-item label="省:" label-width="35px" class="w-170">
              <el-select v-model="table.where.pid"  @change="handleChangeProv(table.where.pid)" placeholder='请选择省' clearable>
                <el-option v-for="option in provArr" :value="option.pid" :key="option.pid" :label="option.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="市:" label-width="35px" class="w-170">
              <el-select v-model="table.where.cid"  @change="handleChangeCity(table.where.cid)" placeholder='请选择市' clearable>
                <el-option v-for="option in cityArr" :value="option.cid" :key="option.cid" :label="option.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="县/区:" label-width="62px" class="w-200">
              <el-select v-model="table.where.aid"  @change="$forceUpdate()" placeholder='请选择县/区' clearable>
                <el-option v-for="option in districtArr " :value="option.aid" :key="option.aid" :label="option.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon ml-20">搜素</el-button>
              <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
              <el-button type="primary" @click="handleTrans"  class="el-icon-s-promotion">转账</el-button>
            </el-form-item>
      </el-form>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)" highlight-current-row :stripe=true>
        <template slot-scope="{index}">
          <el-table-column type="selection" width="45" align="center" fixed="left"/>
          <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left" show-overflow-tooltip/>
          <el-table-column prop="order_id" label="订单编号"  show-overflow-tooltip min-width="120"/>
          <el-table-column prop="payment_time" label="转账时间"  show-overflow-tooltip min-width="100"/>
          <el-table-column prop="transfer_status" label="转账状态"  show-overflow-tooltip min-width="120"/>
          <el-table-column prop="err_code_des" label="失败原因"  show-overflow-tooltip min-width="180"/>
          <el-table-column prop="phone" label="手机号"  show-overflow-tooltip min-width="70"/>
          <el-table-column prop="name" label="姓名"  show-overflow-tooltip min-width="90"/>
          <el-table-column prop="price" label="转账金额(元)"  show-overflow-tooltip min-width="140"/>
          <el-table-column prop="set_area" label="所属地区"  show-overflow-tooltip min-width="160"/>
          <el-table-column label="操作" width="200px" align="center" :resizable="false"  fixed="right">
            <template slot-scope="{row}"  v-if="row.is_success!=1">
              <el-link  slot="reference" @click="wx_transfer(row)" icon="el-icon-s-promotion" type="primary" :underline="false" 
              v-if="permission.includes('sys:wxpay_log:transfer') && (row.transfer_status !='成功')">转账</el-link>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
      
      <el-dialog v-dialogDrag title="微信转账" :visible.sync="showEdit" @closed="form={}" :destroy-on-close="true" :lock-scroll="false">
				<el-card shadow="never">
          <el-form :model="form" ref="form" label-width="150px" :rules="editRules" >
                <el-form-item label="超级管理员手机号：">
                  <el-input v-model="scope" clearable class='input163' disabled/>
                  <el-button type="primary" @click="handleCode" class="ele-btn-icon ml-20" v-if="show">获取验证码</el-button>
                  <el-button v-else style="background-color:#33cc99; border-color:#33cc99;m" class="ml-20" type="primary">{{count}}秒后重试</el-button>
                </el-form-item>
                <el-form-item label="转账手机号：" prop="phone">
                  <el-input v-model="form.phone" placeholder="请输入转账手机号" class="input163" clearable/>
                </el-form-item>
                <el-form-item label="转账金额(元)：" prop="price">
                  <el-input v-model="form.price" placeholder="请输入转账金额" class="input163" clearable/>
                </el-form-item>
                <el-form-item label="验证码(元)：" prop="code">
                  <el-input v-model="form.code" placeholder="请输入验证码" class="input163" clearable/>
                </el-form-item>
              </el-form>
        </el-card>
      <div slot="footer">
        <el-button @click="showEdit=false">取消</el-button>
        <el-button type="primary" @click="save">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style>
.ele-form-mysearch{float: right}
</style>
<script>
import { mapGetters } from "vuex";

export default {
  name: "SysUser",
  data() {
    return {
      scope:'159****8888',
      true_mobile:'',
      count:'',
      show: true,
      showEdit:false,
      form:{},
      table: {url: '/PayLog/wxpay_log_list', where: {}},  // 表格配置
      choose: [],  // 表格选中数据
      editForm: {},  // 表单数据
      checkForm:{},
      editRules: {  // 表单验证规则
				phone:[{
					required:true,
					message: '请输入转账手机号',
					trigger: 'blur'
				}, {
					pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
					message: '请输入正确的手机号',
					trigger: 'blur'
				}],
				price:[{
					required:true,
					message: '请输入转账金额',
					trigger: 'blur'
				},{
					pattern: /^([0-9][0-9]*)+(.[0-9]{1,2})?$/, 
					message: '请输入大于0的有效数字', 
					trigger: 'blur'
				}],
				code:[{
					required:true,
					message: '请输入验证码',
					trigger: 'blur'
				}],
      },
      dialogTableVisibleCheck:false,
      dialogTableVisibleChatRecord:false,
      provArr:[],
      cityArr:[],
      districtArr:[],
      audioArr:[],
      urgentList:[],
      imageUrl:false,
      headImg:'',
      zoom:12,
      center:[104.07,30.67]
    }
  },
  created(){
    this.$http.get('/common/province_list').then(res=>{
      let data=JSON.parse(res.data)
      this.provArr=data
    })

    this.$http.get('/admin/getSuperAdmin').then(res=>{
      this.scope = res.data.hide_mobile
      this.true_mobile = res.data.mobile
    })
  },
  computed: {
    ...mapGetters(["permission"]),
  },

  mounted() {
  },
  methods: {
 
     save(){
        this.form.type=1;
        this.$http.post('/finance/alipay_transfer', this.form).then(res => {
        
          if(res.data.code==0){
             this.showEdit=false;
             this.$message({type: 'success', message: res.data.msg});
          }else{
             this.$message.error(res.data.msg);
          }

        }).catch(e=>{
          this.$message.error(e.message);
        })
    },
    handleTrans(){
      this.showEdit=true;
    },
     //获取验证码
    handleCode(){
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000)
        }
      this.$http.post('/login/getCode', {phone:this.true_mobile}).then(res => {
        if (res.data.code === 0) {
          this.$message({type: 'success', message: res.data.msg});
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
  },
    /**
     *选择省
     **/
    handleChangeProv(e){
      /** 获取被选省份的pid**/
      let pid=''
      this.provArr.forEach(function(item){
        if(item.pid==e){
          pid=item.pid
        }
      })
      /** 根据被选省份的pid获取省市下面的市**/
      this.$http.post('/common/city_list',{pid:pid}).then(res=>{
        let data=JSON.parse(res.data)
        this.cityArr=data
        /** 选择省份清空市县**/
        this.table.where.cid=''
        this.table.where.aid=''
      })
    },
    /**
     *选择市
     **/
    handleChangeCity(e){
			if(e){
      /** 获取被选市的cid**/
      let cid=''
      this.cityArr.forEach(function(item){
        if(item.cid==e){
          cid=item.cid
        }
      })
      /** 根据被选市的cid获取市下面的县**/
      this.$http.post('/common/area_list',{cid:cid}).then(res=>{
        let data=JSON.parse(res.data)
        this.districtArr=data
        /** 选择省份清空县**/
        this.table.where.aid=''
      })
			}else{
				this.table.where.pid = ''
				this.table.where.aid = ''
			}
    },
    //微信转账
    wx_transfer(row){
      this.$confirm('确定要转账吗?', '提示', {type: 'warning'}).then(() => {
        const loading = this.$loading({lock: true});
        this.$http.post('/PayLog/wx_transfer', {id: row.id}).then(res => {
          loading.close();
          if (res.data.code === 0) {
            this.$message({type: 'success', message: res.data.msg});
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          loading.close();
          this.$message.error(e.message);
        });
      })

    },

  }
}
</script>

